import React from 'react';

import styles from 'pages/LiveClassroom/components/RightPanel/style.module.scss';

const StudentDetails = ({ selectedUser: { name, status, time } }) => (
  <div className={styles.card}>
    <p>
      <strong>Name:</strong> {name}
    </p>
    <p>
      <strong>Status:</strong> {status}
    </p>
    <p>
      <strong>Working for:</strong> {time}
    </p>
  </div>
);

export default StudentDetails;
